import React from 'react';

interface Props {
	size: number;
}

export const EducationIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>education</title>
		<path d='M12.26 7.52a.43.43 0 01-.43-.43C11.83 3 9.73 3 9 3a.43.43 0 01-.43-.43.43.43 0 01.43-.45c1.66 0 3.65.87 3.65 5a.43.43 0 01-.43.43zM15.14 4.8a.53.53 0 01-.17 0 .42.42 0 01-.26-.39c0-2.67 1.45-4.09 4.21-4.09a.42.42 0 01.39.27.41.41 0 01-.1.47l-3.77 3.61a.43.43 0 01-.3.13zm2.59-3.54a2.44 2.44 0 00-2 2z' />
		<path d='M14.05 23.72a6 6 0 01-2.05-.37 6.23 6.23 0 01-4.78-.24 10 10 0 01-5-5.65C.41 12.8 2 7.84 5.65 6.41A6.59 6.59 0 0112 7.5a6.59 6.59 0 016.35-1.09c3.65 1.43 5.24 6.39 3.48 11.05a10 10 0 01-5 5.65 6.79 6.79 0 01-2.78.61zM12 22.45a.45.45 0 01.16 0h.08a5.34 5.34 0 004.19-.2 9.08 9.08 0 004.57-5.1c1.6-4.22.27-8.68-3-9.94a5.84 5.84 0 00-5.77 1.16.42.42 0 01-.54 0A5.84 5.84 0 006 7.21c-3.25 1.26-4.58 5.72-3 9.94a9.08 9.08 0 004.59 5.17 5.34 5.34 0 004.19.2h.08a.45.45 0 01.14-.07z' />
	</svg>
);
